import { styled } from '@mui/material/styles';

export const StyledSnackbarWrapperDiv = styled('div')`
  .notistack-SnackbarContainer {
    bottom: 32px !important;
    gap: 12px;

    & .notistack-CollapseWrapper {
      padding: 0 !important;
    }
  }

  .notistack-MuiContent {
    box-shadow: 0px 0px 4px rgba(15, 15, 15, 0.16) !important;
    padding: 12px 16px !important;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 13px;
    line-height: 28px;
    letter-spacing: normal;
  }

  & .notistack-MuiContent #notistack-snackbar {
    font-size: 13px;
    line-height: 28px;
    max-width: 570px;
    padding: 0 !important;

    & svg {
      font-size: 18px;
      height: 28px;
      margin-inline-end: 11px;
    }
  }

  & .notistack-MuiContent-error {
    background-color: ${({ theme }) => theme.palette.error.light} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;

    & svg {
      color: ${({ theme }) => theme.palette.error.main};
    }
  }

  & .notistack-MuiContent-info {
    background-color: ${({ theme }) => theme.palette.info.light} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;

    & svg {
      color: ${({ theme }) => theme.palette.info.main};
    }
  }

  & .notistack-MuiContent-success {
    background-color: ${({ theme }) => theme.palette.success.light} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;

    & svg {
      color: ${({ theme }) => theme.palette.success.main};
    }
  }

  & .notistack-MuiContent-warning {
    background-color: ${({ theme }) => theme.palette.warning.light} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;

    & svg {
      color: ${({ theme }) => theme.palette.warning.main};
    }
  }
`;
